<template>
  <div id="main" class="main-search">
    <div class="logo-anyida">
      <a href="http://www.anyidacylinders.com/" target="_self">
        <img src="../assets/logo.png" />
      </a>
    </div>
    <section class="main-content">
      <div class="logo">
        <img src="../assets/cylinder.png" />
      </div>
      <div class="searh_input">
        <input
          class="cylin-input"
          autocomplete="on"
          type="text"
          v-model="cylinderNumber"
          onkeyup="this.value=this.value.replace(/[^\d]/g,'') "
          maxlength="12"
          placeholder="输入气瓶号查询"
          @keyup.enter="search"
        />
        <span>
          <button class="btn" @click="search">搜索</button>
        </span>
      </div>
    </section>
    <div class="foot">
      <a href="http://www.anyidacylinders.com/">
        <span>天津安易达复合气瓶有限公司</span>
      </a>
      版权所有
      <a href="http://beian.miit.gov.cn">
        <span>津ICP备19005314号-1</span>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      cylinderNumber: ""
    };
  },
  methods: {
    search: function() {
      var cylinder = this.cylinderNumber.trim();
      if (cylinder == "") {
        alert("请输入钢瓶编号");
        return;
      }
      this.$router.push({
        path: "/cylinderInfo",
        query: { epc: this.cylinderNumber }
      });
    }
  }
};
</script>

<style scoped>
.logo-anyida {
  position: absolute;
  width: 135px;
  height: 55px;
  top: 20px;
  left: 40px;
}
.main-search {
  width: 100%;
  height: 100%;
  display: flex;
  /*justify-content: center;*/
  /* align-items: center;
  flex-direction: column; */
  flex-flow: row wrap;
}

.main-content {
  margin-top: 70px;
  text-align: center;

  width: 100%;

  align-self: flex-start;
}

.logo {
  margin-bottom: 10px;
  text-align: center;
  padding-right: 86px;
}

.cylin-input {
  text-align: center;
  height: 41px;
  font-size: 18px;
  width: 40%;
  background: #8080801c;
  border-radius: 24px;
  border: none;
}

.btn {
  background: #62accc;
  border: none;
  color: #fff;
  cursor: pointer;
  display: inline-block;
  font-size: 14px;
  padding: 8px;
  box-sizing: content-box;
  border-radius: 22px;
  white-space: nowrap;
  text-align: center;
  height: 1.6rem;
  width: 60px;
}
.btn:hover {
  box-shadow: 5px 5px 5px grey;
}
.foot {
  font-size: 12px;
  color: #000000;
  width: 100%;
  align-self: flex-end;
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/searchPage.vue